module.exports = __webpack_public_path__ + "static/media/member nalas-01.08bf1a96.png";